function Ae(r, e) {
  (e == null || e > r.length) && (e = r.length);
  for (var t = 0, o = Array(e); t < e; t++) o[t] = r[t];
  return o;
}
function fr(r) {
  if (Array.isArray(r)) return Ae(r);
}
function dr(r) {
  if (r === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return r;
}
function cn(r, e, t, o, a, s, u) {
  try {
    var d = r[s](u), p = d.value;
  } catch (g) {
    return void t(g);
  }
  d.done ? e(p) : Promise.resolve(p).then(o, a);
}
function H(r) {
  return function() {
    var e = this, t = arguments;
    return new Promise(function(o, a) {
      var s = r.apply(e, t);
      function u(p) {
        cn(s, o, a, u, d, "next", p);
      }
      function d(p) {
        cn(s, o, a, u, d, "throw", p);
      }
      u(void 0);
    });
  };
}
function gr(r, e, t) {
  return e = ye(e), hr(r, Ke() ? Reflect.construct(e, t || [], ye(r).constructor) : e.apply(r, t));
}
function x(r, e) {
  if (!(r instanceof e)) throw new TypeError("Cannot call a class as a function");
}
function vr(r, e, t) {
  if (Ke()) return Reflect.construct.apply(null, arguments);
  var o = [null];
  o.push.apply(o, e);
  var a = new (r.bind.apply(r, o))();
  return t && we(a, t.prototype), a;
}
function un(r, e) {
  for (var t = 0; t < e.length; t++) {
    var o = e[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(r, bn(o.key), o);
  }
}
function ee(r, e, t) {
  return e && un(r.prototype, e), t && un(r, t), Object.defineProperty(r, "prototype", {
    writable: !1
  }), r;
}
function hn(r, e) {
  var t = typeof Symbol < "u" && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = Sn(r)) || e) {
      t && (r = t);
      var o = 0, a = function() {
      };
      return {
        s: a,
        n: function() {
          return o >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[o++]
          };
        },
        e: function(p) {
          throw p;
        },
        f: a
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var s, u = !0, d = !1;
  return {
    s: function() {
      t = t.call(r);
    },
    n: function() {
      var p = t.next();
      return u = p.done, p;
    },
    e: function(p) {
      d = !0, s = p;
    },
    f: function() {
      try {
        u || t.return == null || t.return();
      } finally {
        if (d) throw s;
      }
    }
  };
}
function Z(r, e, t) {
  return (e = bn(e)) in r ? Object.defineProperty(r, e, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : r[e] = t, r;
}
function ye(r) {
  return ye = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  }, ye(r);
}
function pr(r, e) {
  if (typeof e != "function" && e !== null) throw new TypeError("Super expression must either be null or a function");
  r.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: r,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(r, "prototype", {
    writable: !1
  }), e && we(r, e);
}
function yr(r) {
  try {
    return Function.toString.call(r).indexOf("[native code]") !== -1;
  } catch {
    return typeof r == "function";
  }
}
function Ke() {
  try {
    var r = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Ke = function() {
    return !!r;
  })();
}
function wr(r) {
  if (typeof Symbol < "u" && r[Symbol.iterator] != null || r["@@iterator"] != null) return Array.from(r);
}
function mr() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ln(r, e) {
  var t = Object.keys(r);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(r);
    e && (o = o.filter(function(a) {
      return Object.getOwnPropertyDescriptor(r, a).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function T(r) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? ln(Object(t), !0).forEach(function(o) {
      Z(r, o, t[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(t)) : ln(Object(t)).forEach(function(o) {
      Object.defineProperty(r, o, Object.getOwnPropertyDescriptor(t, o));
    });
  }
  return r;
}
function hr(r, e) {
  if (e && (typeof e == "object" || typeof e == "function")) return e;
  if (e !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
  return dr(r);
}
function C() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var r, e, t = typeof Symbol == "function" ? Symbol : {}, o = t.iterator || "@@iterator", a = t.toStringTag || "@@toStringTag";
  function s(M, P, K, be) {
    var Ee = P && P.prototype instanceof d ? P : d, ie = Object.create(Ee.prototype);
    return A(ie, "_invoke", function(I, O, W) {
      var B, j, E, V = 0, ae = W || [], Y = !1, J = {
        p: 0,
        n: 0,
        v: r,
        a: ne,
        f: ne.bind(r, 4),
        d: function(R, k) {
          return B = R, j = 0, E = r, J.n = k, u;
        }
      };
      function ne(R, k) {
        for (j = R, E = k, e = 0; !Y && V && !U && e < ae.length; e++) {
          var U, F = ae[e], se = J.p, re = F[2];
          R > 3 ? (U = re === k) && (E = F[(j = F[4]) ? 5 : (j = 3, 3)], F[4] = F[5] = r) : F[0] <= se && ((U = R < 2 && se < F[1]) ? (j = 0, J.v = k, J.n = F[1]) : se < re && (U = R < 3 || F[0] > k || k > re) && (F[4] = R, F[5] = k, J.n = re, j = 0));
        }
        if (U || R > 1) return u;
        throw Y = !0, k;
      }
      return function(R, k, U) {
        if (V > 1) throw TypeError("Generator is already running");
        for (Y && k === 1 && ne(k, U), j = k, E = U; (e = j < 2 ? r : E) || !Y; ) {
          B || (j ? j < 3 ? (j > 1 && (J.n = -1), ne(j, E)) : J.n = E : J.v = E);
          try {
            if (V = 2, B) {
              if (j || (R = "next"), e = B[R]) {
                if (!(e = e.call(B, E))) throw TypeError("iterator result is not an object");
                if (!e.done) return e;
                E = e.value, j < 2 && (j = 0);
              } else j === 1 && (e = B.return) && e.call(B), j < 2 && (E = TypeError("The iterator does not provide a '" + R + "' method"), j = 1);
              B = r;
            } else if ((e = (Y = J.n < 0) ? E : I.call(O, J)) !== u) break;
          } catch (F) {
            B = r, j = 1, E = F;
          } finally {
            V = 1;
          }
        }
        return {
          value: e,
          done: Y
        };
      };
    }(M, K, be), !0), ie;
  }
  var u = {};
  function d() {
  }
  function p() {
  }
  function g() {
  }
  e = Object.getPrototypeOf;
  var w = [][o] ? e(e([][o]())) : (A(e = {}, o, function() {
    return this;
  }), e), y = g.prototype = d.prototype = Object.create(w);
  function D(M) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(M, g) : (M.__proto__ = g, A(M, a, "GeneratorFunction")), M.prototype = Object.create(y), M;
  }
  return p.prototype = g, A(y, "constructor", g), A(g, "constructor", p), p.displayName = "GeneratorFunction", A(g, a, "GeneratorFunction"), A(y), A(y, a, "Generator"), A(y, o, function() {
    return this;
  }), A(y, "toString", function() {
    return "[object Generator]";
  }), (C = function() {
    return {
      w: s,
      m: D
    };
  })();
}
function A(r, e, t, o) {
  var a = Object.defineProperty;
  try {
    a({}, "", {});
  } catch {
    a = 0;
  }
  A = function(s, u, d, p) {
    function g(w, y) {
      A(s, w, function(D) {
        return this._invoke(w, y, D);
      });
    }
    u ? a ? a(s, u, {
      value: d,
      enumerable: !p,
      configurable: !p,
      writable: !p
    }) : s[u] = d : (g("next", 0), g("throw", 1), g("return", 2));
  }, A(r, e, t, o);
}
function we(r, e) {
  return we = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, o) {
    return t.__proto__ = o, t;
  }, we(r, e);
}
function br(r) {
  return fr(r) || wr(r) || Sn(r) || mr();
}
function Sr(r, e) {
  if (typeof r != "object" || !r) return r;
  var t = r[Symbol.toPrimitive];
  if (t !== void 0) {
    var o = t.call(r, e);
    if (typeof o != "object") return o;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(r);
}
function bn(r) {
  var e = Sr(r, "string");
  return typeof e == "symbol" ? e : e + "";
}
function He(r) {
  "@babel/helpers - typeof";
  return He = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, He(r);
}
function Sn(r, e) {
  if (r) {
    if (typeof r == "string") return Ae(r, e);
    var t = {}.toString.call(r).slice(8, -1);
    return t === "Object" && r.constructor && (t = r.constructor.name), t === "Map" || t === "Set" ? Array.from(r) : t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? Ae(r, e) : void 0;
  }
}
function De(r) {
  var e = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return De = function(t) {
    if (t === null || !yr(t)) return t;
    if (typeof t != "function") throw new TypeError("Super expression must either be null or a function");
    if (e !== void 0) {
      if (e.has(t)) return e.get(t);
      e.set(t, o);
    }
    function o() {
      return vr(t, arguments, ye(this).constructor);
    }
    return o.prototype = Object.create(t.prototype, {
      constructor: {
        value: o,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), we(o, t);
  }, De(r);
}
var ge = "1.70.7", ke = "2025-09-11 11:10:07 AM";
function G(r) {
  for (var e, t = arguments.length, o = new Array(t > 1 ? t - 1 : 0), a = 1; a < t; a++)
    o[a - 1] = arguments[a];
  (e = console).log.apply(e, ["".concat(We(), " ").concat(r)].concat(o));
}
function _(r) {
  for (var e, t = arguments.length, o = new Array(t > 1 ? t - 1 : 0), a = 1; a < t; a++)
    o[a - 1] = arguments[a];
  (e = console).warn.apply(e, ["".concat(We(), " ").concat(r)].concat(o));
}
function N(r) {
  for (var e, t = new Error().stack, o = arguments.length, a = new Array(o > 1 ? o - 1 : 0), s = 1; s < o; s++)
    a[s - 1] = arguments[s];
  (e = console).error.apply(e, ["".concat(We(), " ").concat(r)].concat(a, ["stack", t]));
}
function We() {
  return "[".concat(ve(), "] [v").concat(ge, "] ");
}
function ve(r) {
  var e = r || /* @__PURE__ */ new Date(), t = e.getFullYear(), o = String(e.getMonth() + 1).padStart(2, "0"), a = String(e.getDate()).padStart(2, "0"), s = String(e.getHours()).padStart(2, "0"), u = String(e.getMinutes()).padStart(2, "0"), d = String(e.getSeconds()).padStart(2, "0"), p = String(e.getMilliseconds()).padStart(3, "0");
  return "".concat(t, "-").concat(o, "-").concat(a, " ").concat(s, ":").concat(u, ":").concat(d, ".").concat(p);
}
var In = /* @__PURE__ */ function() {
  function r() {
    x(this, r);
  }
  return ee(r, null, [{
    key: "isIOS",
    value: function() {
      return !!(!window.chrome && window.webkit) && "ontouchend" in document;
    }
  }, {
    key: "isMacOS",
    value: function() {
      return !!(!window.chrome && window.webkit) && !("ontouchend" in document);
    }
  }]);
}(), On = function() {
  var e, t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window;
  return !!((e = t.chrome) !== null && e !== void 0 && e.webview) && !!(t.unifyConfig || t.android_config);
}, Ir = function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window;
  return !!(e.chrome && e.webkit && (e.unifyConfig || e.android_config));
}, Ue = function() {
  var e, t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window;
  return ((e = t.unifyConfig) === null || e === void 0 || (e = e.systemParam) === null || e === void 0 || (e = e.deviceOs) === null || e === void 0 ? void 0 : e.toLowerCase()) === "ios" || Ge && In.isIOS();
}, Ve = function() {
  var e, t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window;
  return ((e = t.unifyConfig) === null || e === void 0 || (e = e.systemParam) === null || e === void 0 || (e = e.deviceOs) === null || e === void 0 ? void 0 : e.toLowerCase()) === "mac" || Ge && In.isMacOS();
}, Or = function() {
  var e, t, o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window;
  return ((e = o.unifyConfig) === null || e === void 0 || (e = e.systemParam) === null || e === void 0 || (e = e.deviceOs) === null || e === void 0 ? void 0 : e.toLowerCase()) === "mac" && ((t = o.unifyConfig) === null || t === void 0 || (t = t.systemParam) === null || t === void 0 || (t = t.webviewName) === null || t === void 0 ? void 0 : t.toLowerCase()) === "webkit";
}, jr = function() {
  var e, t, o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window;
  return ((e = o.unifyConfig) === null || e === void 0 || (e = e.systemParam) === null || e === void 0 || (e = e.deviceOs) === null || e === void 0 ? void 0 : e.toLowerCase()) === "mac" && ((t = o.unifyConfig) === null || t === void 0 || (t = t.systemParam) === null || t === void 0 || (t = t.webviewName) === null || t === void 0 ? void 0 : t.toLowerCase()) === "cef";
}, Cr = function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window;
  return Ue(e) || Ve(e);
}, jn = function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window;
  return !!(e.android && e.android_config);
}, Cn = function() {
  var e;
  return ((e = window) === null || e === void 0 || (e = e.unifyConfig) === null || e === void 0 || (e = e.systemParam) === null || e === void 0 || (e = e.deviceOs) === null || e === void 0 ? void 0 : e.toLowerCase()) === "linux";
}, $ = {
  isAndroid: jn,
  isWebView2: On,
  isCEF: Ir,
  isMacOSOrIOS: Cr,
  isMacOS: Ve,
  isMacOSWebkit: Or,
  isMacOSCEF: jr,
  isIOS: Ue,
  isLinux: Cn
}, Ge = !1;
function fn() {
  var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0, e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : void 0, t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
  if (t || !window.unifyConfig && !window.android_config && _("The @zoom/hybrid-jssdk only supports UnifyWebView. Please ensure that the window.unifyConfig or window.android_config object exists, or set legacyPlatformDetection: true to skip UnifyWebView detection."), $.isCEF(window)) {
    var o;
    return G("isCEF"), (e == null ? void 0 : e.linuxJSBridgeObject) || ((o = window.webkit) === null || o === void 0 || (o = o.messageHandlers) === null || o === void 0 ? void 0 : o.jsOCHelper);
  }
  if ($.isWebView2(window)) {
    var a;
    return G("isWebView2"), (e == null ? void 0 : e.windowJSBridgeObject) || ((a = window.chrome) === null || a === void 0 ? void 0 : a.webview);
  }
  if ($.isMacOSOrIOS(window)) {
    var s, u;
    return G("isMacOSOrIOS"), (e == null ? void 0 : e.macOrIOSJSBridgeObject) || ((s = window.webkit) === null || s === void 0 || (s = s.messageHandlers) === null || s === void 0 ? void 0 : s.unifyJSObj) || ((u = window.webkit) === null || u === void 0 || (u = u.messageHandlers) === null || u === void 0 ? void 0 : u.jsOCHelper);
  }
  if ($.isAndroid(window))
    return G("isAndroid"), (e == null ? void 0 : e.androidJSBridgeObject) || window.android;
  r || _("[hybrid/bridge] Not found jsbridge object, if you are in dev proxy mode, you can skip throw by set getInstance({ config: { softRegisterBridge: true } })!");
}
function Nr(r) {
  Ge = r;
}
function Ur() {
  return jn(window) || Ue(window) || On(window) || Ve(window) || Cn();
}
var Nn = 60, kr = 1, pe = "*";
function Mr(r) {
  return {
    jsCallId: r,
    returnCode: 0,
    result: "success, this is fake response for no response request"
  };
}
/**
 * @license
 * MIT LICENSE
 * Copyright 2011 Jon Leighton
 * Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */
var X = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
function Tr(r) {
  for (var e = new Uint8Array(r), t = e.byteLength, o = t % 3, a = t - o, s = "", u, d, p, g, w, y = 0; y < a; y = y + 3)
    w = e[y] << 16 | e[y + 1] << 8 | e[y + 2], u = (w & 16515072) >> 18, d = (w & 258048) >> 12, p = (w & 4032) >> 6, g = w & 63, s += X[u] + X[d] + X[p] + X[g];
  return o == 1 ? (w = e[a], u = (w & 252) >> 2, d = (w & 3) << 4, s += X[u] + X[d] + "==") : o == 2 && (w = e[a] << 8 | e[a + 1], u = (w & 64512) >> 10, d = (w & 1008) >> 4, p = (w & 15) << 2, s += X[u] + X[d] + X[p] + "="), s;
}
function Er() {
  return "id_" + Date.now() + "_" + Math.random().toString(16).slice(2);
}
function dn() {
  return Math.random().toString(16).slice(2);
}
function kn(r, e) {
  var t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, o = r, a, s;
  if (o || (o = {}), e)
    for (a in e)
      (t || !(a in o)) && (s = e[a], o[a] = s && s.constructor === Object ? kn(o[a], s, t) : s);
  return o;
}
function Br(r) {
  try {
    return JSON.parse(r);
  } catch (e) {
    N("safeJsonParse got a invalid json string [".concat(r, "] ").concat(e));
  }
  return {};
}
function gn(r) {
  var e = r.replace(/\./g, "\\.");
  return e = e.replace(/\*/g, ".*"), e = "^" + e + "$", new RegExp(e);
}
function vn(r, e) {
  try {
    var t = e.some(function(a) {
      return a.test(r);
    });
    if (t)
      return !0;
    var o = new URL(r).hostname;
    return e.some(function(a) {
      return a.test(o);
    });
  } catch (a) {
    console.warn("[@zoom/hybrid-jssdk] isValidOrigin error: encountered an invalid domain URL", a);
  }
  return !1;
}
function _e() {
}
function pn(r, e) {
  for (var t in r)
    r[t] && (e[t] = r[t]);
}
function yn(r) {
  try {
    for (var e = arguments.length, t = new Array(e > 1 ? e - 1 : 0), o = 1; o < e; o++)
      t[o - 1] = arguments[o];
    return r.apply(void 0, t);
  } catch (a) {
    return console.error("[@zoom/hybrid-jssdk] safeInvoke error", a), console.trace("safeInvoke trace"), null;
  }
}
function Pr(r, e) {
  for (var t = r; t !== null; ) {
    var o = Object.getOwnPropertyDescriptor(t, e);
    if (o)
      return o.writable === !0 || o.set !== void 0;
    t = Object.getPrototypeOf(t);
  }
  return !1;
}
var wn = /* @__PURE__ */ function() {
  function r() {
    x(this, r), Z(this, "handlers", void 0), this.handlers = [];
  }
  return ee(r, [{
    key: "use",
    value: function(t) {
      return this.handlers.push(t), this.handlers.length - 1;
    }
    /**
     * Remove an interceptor from the stack
     *
     * @param {Number} id The ID that was returned by `use`
     *
     * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
     */
  }, {
    key: "eject",
    value: function(t) {
      return this.handlers[t] ? (this.handlers[t] = null, !0) : !1;
    }
    /**
     * Clear all interceptors from the stack
     *
     * @returns {void}
     */
  }, {
    key: "clear",
    value: function() {
      this.handlers && (this.handlers = []);
    }
    /**
     * return {Boolean} `true` if the interceptor fn was empty, `false` otherwise
     */
  }, {
    key: "empty",
    value: function() {
      return this.handlers.filter(function(t) {
        return t;
      }).length === 0;
    }
  }]);
}(), Rr = /* @__PURE__ */ function() {
  function r() {
    x(this, r);
  }
  return ee(r, [{
    key: "normalizeResponse",
    value: function(t) {
      var o, a, s, u = (o = t.data) !== null && o !== void 0 ? o : t;
      return u.jsCallId === "" && (u.result = u.result || {}, u.result.notification = u.msg_type), T(T({
        returnCode: u.code
      }, u), {}, {
        result: T(T({}, u.jsCallId !== "" && ((a = u.context) !== null && a !== void 0 && a.page) ? {
          notification: (s = u.context) === null || s === void 0 ? void 0 : s.page
        } : {}), u.jsCallId === "" && u.msg_type ? {
          notification: u.msg_type
        } : {})
      });
    }
  }, {
    key: "matchResponse",
    value: function(t) {
      if ("data" in t && Object.keys(t).length === 1) {
        var o = t.data;
        if ("code" in o && "success" in o)
          return !0;
      }
      return "code" in t && "success" in t;
    }
  }, {
    key: "postProcessAsNotification",
    value: function(t) {
      var o, a, s = (o = t.data) !== null && o !== void 0 ? o : t;
      return s.jsCallId !== "" && ((a = s.context) === null || a === void 0 ? void 0 : a.page);
    }
  }]);
}();
function Fr(r) {
  return JSON.stringify(r, function(e, t) {
    return (t == null ? void 0 : t.constructor) === ImageData ? Lr(t) : t;
  });
}
function Lr(r) {
  return {
    width: r.width,
    height: r.height,
    bitmap: "data:object/Uint8ClampedArray;base64," + Tr(r.data.buffer)
  };
}
var Ze = /* @__PURE__ */ function() {
  function r() {
    x(this, r);
  }
  return ee(r, [{
    key: "storeBody",
    value: function() {
      var e = H(/* @__PURE__ */ C().m(function o(a, s) {
        var u, d, p;
        return C().w(function(g) {
          for (; ; ) switch (g.p = g.n) {
            case 0:
              if (g.p = 0, a) {
                g.n = 1;
                break;
              }
              return g.a(2, "");
            case 1:
              return g.n = 2, this.serializeBody(a);
            case 2:
              return u = g.v, d = u, d.protocol = s, g.n = 3, this.callNativeStore(d);
            case 3:
              return g.a(2, g.v);
            case 4:
              return g.p = 4, p = g.v, N("@zoom/hybrid-jssdk hook fetch storeBody error", p), g.a(2, "");
          }
        }, o, this, [[0, 4]]);
      }));
      function t(o, a) {
        return e.apply(this, arguments);
      }
      return t;
    }()
  }, {
    key: "serializeBody",
    value: function() {
      var e = H(/* @__PURE__ */ C().m(function o(a) {
        var s;
        return C().w(function(u) {
          for (; ; ) switch (u.n) {
            case 0:
              return s = {
                encoding: "text",
                body: ""
              }, u.a(2, new Promise(function(d) {
                if (a instanceof ArrayBuffer || typeof SharedArrayBuffer < "u" && a instanceof SharedArrayBuffer)
                  s.encoding = "base64", s.body = Me.convertArrayBufferToBase64(a);
                else if (ArrayBuffer.isView(a))
                  s.encoding = "base64", s.body = Me.convertArrayBufferToBase64(a.buffer);
                else if (a instanceof File || a instanceof Blob) {
                  s.encoding = "base64";
                  var p = new FileReader();
                  return p.onload = function(g) {
                    s.body = Tn(g.target.result), d(s);
                  }, p.readAsDataURL(a), !0;
                } else {
                  if (a instanceof FormData)
                    return s.encoding = "formData", Me.convertFormDataToJson(a, function(g) {
                      s.body = g, d(s);
                    }), !0;
                  s.encoding = "text", s.body = a.toString();
                }
                d(s);
              }));
          }
        }, o);
      }));
      function t(o) {
        return e.apply(this, arguments);
      }
      return t;
    }()
  }, {
    key: "callNativeStore",
    value: function() {
      var e = H(/* @__PURE__ */ C().m(function o(a) {
        return C().w(function(s) {
          for (; ; ) switch (s.n) {
            case 0:
              return s.a(2, new Promise(function(u, d) {
                var p = me.getInstance();
                p.postJsMessage({
                  functionName: "http.storeRequestBody",
                  params: a
                }).then(function(g) {
                  if (g.returnCode === 0)
                    u(g.result.bodyId);
                  else {
                    var w;
                    N("http.storeRequestBody failed.", g), d(new Error("[hybrid] http.storeRequestBody failed with returnCode ".concat(g.returnCode, " ").concat((w = g.errorMsg) !== null && w !== void 0 ? w : "")));
                  }
                }).catch(function(g) {
                  N("[hybrid] http.storeRequestBody error", g), d(g);
                });
              }));
          }
        }, o);
      }));
      function t(o) {
        return e.apply(this, arguments);
      }
      return t;
    }()
  }, {
    key: "clearBody",
    value: function() {
      var e = H(/* @__PURE__ */ C().m(function o(a) {
        return C().w(function(s) {
          for (; ; ) switch (s.n) {
            case 0:
              if (a) {
                s.n = 1;
                break;
              }
              return s.a(2);
            case 1:
              return s.a(2, new Promise(function(u, d) {
                var p = me.getInstance();
                p.postJsMessage({
                  functionName: "http.clearRequestBody",
                  params: {
                    bodyId: a
                  }
                }).then(function(g) {
                  if (g.returnCode === 0)
                    u();
                  else {
                    var w;
                    N("http.clearRequestBody failed.", g), d(new Error("[hybrid] http.clearRequestBody failed with returnCode ".concat(g.returnCode, " ").concat((w = g.errorMsg) !== null && w !== void 0 ? w : "")));
                  }
                }).catch(function(g) {
                  N("[hybrid] http.clearRequestBody error", g), d(g);
                });
              }));
          }
        }, o);
      }));
      function t(o) {
        return e.apply(this, arguments);
      }
      return t;
    }()
  }], [{
    key: "getInstance",
    value: function() {
      return r.instance || (r.instance = new r()), r.instance;
    }
  }]);
}();
Z(Ze, "instance", void 0);
var Xe = /* @__PURE__ */ function() {
  function r() {
    x(this, r);
  }
  return ee(r, null, [{
    key: "install",
    value: function() {
      this.originalFetch || (this.originalFetch = window.fetch, window.fetch = /* @__PURE__ */ function() {
        var t = H(/* @__PURE__ */ C().m(function o(a, s) {
          return C().w(function(u) {
            for (; ; ) switch (u.n) {
              case 0:
                return u.n = 1, r.interceptedFetch(a, s);
              case 1:
                return u.a(2, u.v);
            }
          }, o);
        }));
        return function(o, a) {
          return t.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "uninstall",
    value: function() {
      this.originalFetch && (window.fetch = this.originalFetch, this.originalFetch = null);
    }
  }, {
    key: "interceptedFetch",
    value: function() {
      var e = H(/* @__PURE__ */ C().m(function o(a, s) {
        var u, d, p, g, w;
        return C().w(function(y) {
          for (; ; ) switch (y.p = y.n) {
            case 0:
              if (!((s == null ? void 0 : s.body) == null || (s == null ? void 0 : s.body) === "")) {
                y.n = 1;
                break;
              }
              return y.a(2, r.originalFetch.call(window, a, s));
            case 1:
              return u = "", d = Ze.getInstance(), y.p = 2, y.n = 3, d.storeBody(s.body, Mn(a));
            case 3:
              return u = y.v, p = T(T({}, s), {}, {
                headers: T(T({}, s.headers), {}, {
                  "X-ZM-Request-Body-ID": u
                }),
                body: s.body
              }), y.n = 4, r.originalFetch.call(window, a, p);
            case 4:
              return g = y.v, y.n = 5, d.clearBody(u);
            case 5:
              return y.a(2, g);
            case 6:
              return y.p = 6, w = y.v, N("FetchInterceptor error", w), y.n = 7, d.clearBody(u);
            case 7:
              throw w;
            case 8:
              return y.a(2);
          }
        }, o, null, [[2, 6]]);
      }));
      function t(o, a) {
        return e.apply(this, arguments);
      }
      return t;
    }()
  }]);
}();
Z(Xe, "originalFetch", void 0);
var Te = /* @__PURE__ */ function() {
  function r() {
    x(this, r);
  }
  return ee(r, null, [{
    key: "install",
    value: function() {
      this.originalSend || (this.originalSend = XMLHttpRequest.prototype.send, this.originalOpen = XMLHttpRequest.prototype.open, XMLHttpRequest.prototype.open = function(t, o) {
        this._method = t, this._url = o, r.originalOpen.apply(this, arguments);
      }, XMLHttpRequest.prototype.send = /* @__PURE__ */ function() {
        var t = H(/* @__PURE__ */ C().m(function o(a) {
          var s, u, d, p, g, w;
          return C().w(function(y) {
            for (; ; ) switch (y.p = y.n) {
              case 0:
                if (!(a == null || a === "")) {
                  y.n = 1;
                  break;
                }
                return y.a(2, r.originalSend.call(this));
              case 1:
                return s = this.onload, u = this.onerror, d = Ze.getInstance(), p = "", y.p = 2, y.n = 3, d.storeBody(a, Mn(this._url));
              case 3:
                p = y.v, y.n = 5;
                break;
              case 4:
                throw y.p = 4, w = y.v, (g = this.onerror) === null || g === void 0 || g.call(this, w), w;
              case 5:
                return this.setRequestHeader("X-ZM-Request-Body-ID", p), this.onload = /* @__PURE__ */ function() {
                  var D = H(/* @__PURE__ */ C().m(function M(P) {
                    return C().w(function(K) {
                      for (; ; ) switch (K.n) {
                        case 0:
                          return K.n = 1, d.clearBody(p);
                        case 1:
                          s && s.call(this, P);
                        case 2:
                          return K.a(2);
                      }
                    }, M, this);
                  }));
                  return function(M) {
                    return D.apply(this, arguments);
                  };
                }(), this.onerror = /* @__PURE__ */ function() {
                  var D = H(/* @__PURE__ */ C().m(function M(P) {
                    return C().w(function(K) {
                      for (; ; ) switch (K.n) {
                        case 0:
                          return K.n = 1, d.clearBody(p);
                        case 1:
                          u && u.call(this, P);
                        case 2:
                          return K.a(2);
                      }
                    }, M, this);
                  }));
                  return function(M) {
                    return D.apply(this, arguments);
                  };
                }(), y.a(2, r.originalSend.call(this, a));
            }
          }, o, this, [[2, 4]]);
        }));
        return function(o) {
          return t.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "uninstall",
    value: function() {
      this.originalSend && this.originalOpen && (XMLHttpRequest.prototype.send = this.originalSend, XMLHttpRequest.prototype.open = this.originalOpen, this.originalSend = null, this.originalOpen = null);
    }
  }]);
}();
Z(Te, "originalSend", void 0);
Z(Te, "originalOpen", void 0);
var Me = /* @__PURE__ */ function() {
  function r() {
    x(this, r);
  }
  return ee(r, null, [{
    key: "convertArrayBufferToBase64",
    value: function(t) {
      for (var o = new Uint8Array(t), a = "", s = o.byteLength, u = 0; u < s; u++)
        a += String.fromCharCode(o[u]);
      return window.btoa(a);
    }
  }, {
    key: "convertFormDataToJson",
    value: function(t, o) {
      var a = [];
      r.traversalEntries(t, function(s, u) {
        a.push(r.convertSingleFormDataRecordToArray(s, u));
      }), Promise.all(a).then(o).catch(function(s) {
        N("[hybrid] convertFormDataToJson error", s);
      });
    }
  }, {
    key: "convertSingleFormDataRecordToArray",
    value: function(t, o) {
      return new Promise(function(a, s) {
        if (o instanceof File || o instanceof Blob) {
          var u = new FileReader();
          u.onload = function(d) {
            var p = Tn(d.target.result), g = o instanceof File, w = g ? o.name : "blob", y = {
              headers: ['Content-Disposition: form-data; name="'.concat(t, '"; filename="').concat(w, '"')],
              body: p,
              encoding: "base64"
            };
            return o.type ? y.headers.push("Content-Type: ".concat(o.type)) : y.headers.push("Content-Type: application/octet-stream"), a(y), null;
          }, u.onerror = function(d) {
            return N("[hybrid] read formData failed", d), s(Error("[hybrid] read formData failed")), null;
          }, u.readAsDataURL(o);
        } else
          a({
            headers: ['Content-Disposition: form-data; name="'.concat(t, '"')],
            body: o,
            encoding: "text"
          });
      });
    }
  }]);
}();
Z(Me, "traversalEntries", function(r, e) {
  var t = hn(r.entries()), o;
  try {
    for (t.s(); !(o = t.n()).done; ) {
      var a = o.value, s = a[0], u = a[1];
      e && e(s, u);
    }
  } catch (d) {
    t.e(d);
  } finally {
    t.f();
  }
});
function Mn(r) {
  var e;
  if (r instanceof Request ? e = new URL(r.url) : r instanceof URL ? e = r : e = new URL(r), e.protocol === "http:")
    return "http";
  if (e.protocol === "https:")
    return "https";
  throw new Error("Protocol is neither http nor https");
}
function Tn(r) {
  if (!r)
    return "";
  try {
    var e = "base64,", t = r.indexOf(e);
    return t === -1 ? r : r.substring(t + e.length);
  } catch (o) {
    return N("getBase64FromFileReader error:", o), "";
  }
}
function zr() {
  Xe.install(), Te.install();
}
function _r() {
  Xe.uninstall(), Te.uninstall();
}
function Je(r, e) {
  try {
    if (r === "ZoomBundleVersionNumber" || e === "ZoomBundleVersionNumber")
      return console.warn("[hybrid/jssdk] Skip version check for local development build! 🚀"), 1;
    for (var t = r.split(".").map(Number), o = e.split(".").map(Number), a = Math.max(t.length, o.length), s = 0; s < a; s++) {
      var u = t[s] || 0, d = o[s] || 0;
      if (u > d) return 1;
      if (u < d) return -1;
    }
    return 0;
  } catch (p) {
    return console.error("[@zoom/hybrid-jssdk] compareVersions error:", p, "version1", r, "version2", e), -1;
  }
}
function Jr() {
  try {
    var r, e;
    if ((r = window.unifyConfig) !== null && r !== void 0 && r.systemParam)
      return window.unifyConfig.systemParam.clientVersion;
    if (typeof ((e = window.android_config) === null || e === void 0 ? void 0 : e.getSystemParam) == "function")
      return JSON.parse(window.android_config.getSystemParam()).clientVersion;
  } catch (t) {
    console.error("[@zoom/hybrid-jssdk] getClientVersion error:", t, "window.unifyConfig", window.unifyConfig, "window.android_config", window.android_config);
  }
}
var mn = !1;
function me() {
  var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, e = Ar(r), t = fn(e.config.softRegisterBridge, e.platform, e.config.legacyPlatformDetection);
  if (!t && e.config.strictMode)
    throw new Error("[@zoom/hybrid-jssdk] Not found jsbridge object. ".concat(ge, " build at ").concat(ke));
  G("getCurrentJSBridgeObject", t), Nr(e.config.legacyPlatformDetection);
  var o = {}, a = {}, s = {}, u = {}, d = /* @__PURE__ */ new Map(), p = /* @__PURE__ */ new Map(), g = /* @__PURE__ */ new Map(), w, y, D = [], M = [], P = {}, K = {
    info: _e,
    warn: _e,
    error: _e
  }, be = e.debug, Ee = be.enable, ie = be.output, I = T({}, Ee && ie ? ie : K), O = e.config.unifySDKMode ? "unifySdk" : "zoomSdk", W = !window[O], B = W ? "master_".concat(dn()) : "sub_".concat(dn()), j = [], E = Jr(), V = {
    request: new wn(),
    response: new wn()
  }, ae = [];
  e.config.disabledAdapters.includes("AdvancedDiagnosticsAdapter") || (I.info("%c advancedDiagnosticsAdapter enabled!", "color: green; font-weight: bold"), ae.push(new Rr())), Ln();
  function Y(n) {
    J(pe, n);
  }
  function J(n, i) {
    var c = Array.isArray(n) ? n : [n];
    c.forEach(function(l) {
      var f = u[l];
      f ? f.push(i) : u[l] = [i];
    });
  }
  function ne(n) {
    R(pe, n);
  }
  function R(n, i) {
    var c = Array.isArray(n) ? n : [n];
    c.forEach(function(l) {
      if (i) {
        var f = u[l];
        if (f) {
          var v = f.indexOf(i);
          v !== -1 && (f.splice(v, 1), u[l] = f);
        }
      } else
        u[l] = [];
    });
  }
  function k(n) {
    var i, c, l = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      isIOSSupport: !0,
      isAndroidSupport: !0,
      isMacSupport: !0,
      isWindowsSupport: !0,
      isLinuxSupport: !0
    }, f = n.jsCallId, v = n.functionName, S = v === void 0 ? "" : v, h = n.params, m = h === void 0 ? {} : h, b = n.timeout, L = b === void 0 ? e == null || (i = e.config) === null || i === void 0 ? void 0 : i.messageTimeout : b, Q = n.raceMode, ue = Q === void 0 ? !1 : Q, te = n.needResponse, Ce = te === void 0 ? !0 : te, Ne = n.overwriteResponse, Le = Ne === void 0 ? !1 : Ne, oe = n.moduleName, le = oe === void 0 ? "" : oe, fe = n.noDelete, lr = fe === void 0 ? !1 : fe, de = {
      functionName: S,
      params: m,
      timeout: L,
      raceMode: ue,
      needResponse: Ce,
      overwriteResponse: Le,
      moduleName: le,
      noDelete: lr,
      jsCallId: f,
      rejectOnErrorResponse: (c = n.rejectOnErrorResponse) !== null && c !== void 0 ? c : e.config.checkReturnCode
    };
    !S && n.apiName && (de.apiName = n.apiName, de.data = n.data);
    var z = Pn(de);
    return z = JSON.parse(JSON.stringify(T(T({}, z), l))), z = F(z), new Promise(function(on, an) {
      de.needResponse ? Rn(z, on, an) : (I.warn("%c The native client request(".concat(z.functionName || z.apiName, "__").concat(z.jsCallId, ") with needResponse:false."), "color: warn;", de), on(Mr(z.jsCallId)));
      var sn = window.top !== window;
      if (I.info("".concat(sn ? "Iframe" : "", " request %c").concat(z.functionName || z.apiName, "__").concat(z.jsCallId), "color:#909399; font-weight: bold", z), window.top || I.warn("%cThe window.top is not found (possibly in about:blank or sandboxed iframe).", "color: brown; font-weight: bold"), sn)
        if (e.config.iframeSupport)
          U(z);
        else
          return an(new Error("JSBridge does not support calls within iframes. If iframe support is needed, please set the iframeSupport parameter."));
      else {
        var ze;
        (ze = window[O]) === null || ze === void 0 || ze.postMessage(z);
      }
    });
  }
  function U(n) {
    var i;
    (i = window.top) === null || i === void 0 || i.postMessage({
      identityKey: e.config.iframeMessageIdentityKey,
      fromIframeURL: window.location.href,
      request: T({}, n)
    }, "*");
  }
  function F(n) {
    if (V.request.empty())
      return n;
    for (var i = n.functionName, c = n.apiName, l = n.jsCallId, f = n.params, v = n.data, S = V.request.handlers.filter(function(b) {
      return b;
    }), h = 0; h < S.length; h++)
      if (S[h]) {
        var m = S[h]({
          functionName: i,
          apiName: c,
          params: f,
          data: v,
          jsCallId: l
        });
        f = m == null ? void 0 : m.params, v = m == null ? void 0 : m.data, n.params && !f && I.warn("%cThe request interceptor returned empty parameters!!!", "color: brown; font-weight: bold", "interceptor return", m), n.data && !v && I.warn("%cThe request interceptor returned empty data!!!", "color: brown; font-weight: bold", "interceptor return", m);
      }
    return n.params && (n.params = f), n.data && (n.data = v), T({}, n);
  }
  function se(n) {
    if (V.response.empty())
      return n;
    for (var i = n, c = V.response.handlers.filter(function(f) {
      return f;
    }), l = 0; l < c.length; l++)
      c[l] && (i = c[l](i), i || I.warn("%cThe response interceptor should not return an empty response!!!", "color: brown; font-weight: bold", "interceptor response", i));
    return i;
  }
  function re(n) {
    if (n)
      clearTimeout(s[n]), delete s[n], I.info("Remove ".concat(n, " API timer successfully."));
    else {
      for (var i in s)
        clearTimeout(s[i]);
      s = {};
    }
  }
  function En() {
    var n, i;
    o = {}, a = {}, p.clear(), d.clear(), g.clear(), (n = w) === null || n === void 0 || (i = n.destroy) === null || i === void 0 || i.call(n);
  }
  function Bn() {
    u = {};
  }
  function Se(n) {
    try {
      var i;
      if (t || (t = fn(e.config.softRegisterBridge, e.platform, e.config.legacyPlatformDetection)), (i = t) !== null && i !== void 0 && i.noDefaultPostMessage && !W) {
        U(n);
        return;
      }
      if (t) {
        var c = n.iframeWindow;
        n.iframeWindow = null;
        var l = e.config.messageFormat === "string" ? Fr(n) : n;
        if (c && e.config.iframeSupport && (P[n.jsCallId] = c), n.raceMode) {
          var f = en(n);
          if (d.has(f))
            d.get(f).push(n.jsCallId);
          else {
            if (p.set(n.jsCallId, f), d.set(f, [n.jsCallId]), !Ye(n))
              return;
            t.postMessage(l);
          }
        } else {
          if (!Ye(n))
            return;
          t.postMessage(l);
        }
      } else
        I.warn(`%cFailed to post a message. The JS bridge object was not found.
!`, "color: brown; font-weight: bold");
    } catch (v) {
      N("Failed to post a message.", v);
    }
  }
  function Pn(n) {
    var i, c, l, f;
    if (!n.functionName && !n.apiName) {
      var v = "[@zoom/hybrid-jssdk] Invalid message format: Both functionName and apiName cannot be empty.";
      throw N(v, n), new Error(v);
    }
    if (n.functionName && n.apiName && _("[@zoom/hybrid-jssdk] Invalid message format: Both functionName and apiName cannot exist simultaneously.", n), n.timeout !== void 0 && n.timeout < 0) {
      var S = "[@zoom/hybrid-jssdk] Invalid message format: Timeout value cannot be negative. Using the default timeout ".concat(e.config.messageTimeout, " instead.");
      _(S, n), n.timeout = e.config.messageTimeout;
    }
    return T(T({
      iframeWindow: null
    }, n), {}, {
      sdkName: O,
      timeout: (i = (c = n.timeout) !== null && c !== void 0 ? c : e == null || (l = e.config) === null || l === void 0 ? void 0 : l.messageTimeout) !== null && i !== void 0 ? i : Nn,
      jsCallId: (f = n.jsCallId) !== null && f !== void 0 ? f : Er()
    });
  }
  function Rn(n, i, c) {
    var l, f = Date.now();
    if (n.timeout && !n.noDelete) {
      var v = en(n);
      l = setTimeout(function() {
        var S = "The native client did not respond to the API call (".concat(n.functionName || n.apiName, "__").concat(n.jsCallId, "). timeout is ").concat(n.timeout, " seconds");
        er(n), window.top && window.top !== window && window.top.postMessage({
          identityKey: e.config.iframeMessageIdentityKey,
          fromIframeURL: window.location.href,
          purpose: "cleanTimeoutJsCall",
          raceId: v,
          timeoutJsCallId: n.jsCallId
        }, "*"), N(S, n), or({
          reject: c,
          errorMessage: S,
          jsCallId: n.jsCallId
        });
      }, n.timeout * 1e3), s[n.jsCallId] = l;
    }
    g.set(n.jsCallId, c), Fn(n, l, function(S) {
      var h = e.config.longRequestSeconds, m = typeof S == "string" ? JSON.parse(S) : S;
      m = JSON.parse(JSON.stringify(m));
      var b = m;
      m.data && !m.jsCallId && (b = m.data), b = se(b), b || c("[hybrid/bridge] callResponseInterceptor return a empty response, please check your response");
      var L = b, Q = L.returnCode, ue = L.errorCode;
      if (n.rejectOnErrorResponse && (ue || Q)) {
        var te, Ce = b, Ne = Ce.errorCode, Le = Ce.errorMessage;
        I.error("hybrid reject for error response", b), c(new Wr(Le || "hybrid reject for error response ".concat((te = n.functionName) !== null && te !== void 0 ? te : n.apiName), Ne || Q, n.jsCallId, b));
      } else
        i(b);
      if (je(n.jsCallId), l && clearTimeout(l), delete s[n.jsCallId], e.debug.enable) {
        var oe = Date.now(), le = parseFloat((oe - f).toFixed(2)), fe = window.top !== window ? "iframe received " : "";
        h && le >= h * 1e3 ? I.warn("%c ".concat(le, "ms ").concat(fe, " Slow API response ").concat(n.functionName || n.apiName, "__").concat(n.jsCallId, " requestTime: ").concat(ve(new Date(f)), " responseTime: ").concat(ve(new Date(oe))), "font-weight: bold", m) : I.info("".concat(le, "ms ").concat(fe, " response %c").concat(n.functionName || n.apiName, "__").concat(n.jsCallId, "%c requestTime: ").concat(ve(new Date(f)), " responseTime: ").concat(ve(new Date(oe))), "color:#".concat(Q === 0 ? "67C23A" : "F56C6C", ";font-weight: bold"), "", m);
      }
    });
  }
  function Fn(n, i, c) {
    if (o[n.jsCallId] = c, n.overwriteResponse) {
      var l = n.functionName || n.apiName;
      if (a[l]) {
        var f = a[l];
        I.info("remove call id: ", f.callID), clearTimeout(f.timerHandler), je(f.callID), n.overwriteResponse && xn(n);
      }
      a[l] = {
        callID: n.jsCallId,
        timerHandler: i
      };
    }
  }
  function Ie(n) {
    if (window !== window.top) {
      var i = "[@zoom/hybrid-jssdk] can't register globalMessageInterceptor in iframe, only allowed in window.top, current instanceId ".concat(B);
      throw N(i), new Error(i);
    }
    if (!W) {
      var c = "[@zoom/hybrid-jssdk] can't register globalMessageInterceptor on sub instance, current instanceId ".concat(B);
      throw N(c), new Error(c);
    }
    e.config.globalMessageInterceptor = n, I.info("%c register globalMessageInterceptor successfully!", "color: green; font-weight: bold");
  }
  function Oe() {
    if (window !== window.top) {
      var n = "[@zoom/hybrid-jssdk] can't unregister globalMessageInterceptor in iframe, only allowed in window.top, current instanceId ".concat(B);
      throw N(n), new Error(n);
    }
    if (!W) {
      var i = "[@zoom/hybrid-jssdk] can't unregister globalMessageInterceptor on sub instance, current instanceId ".concat(B);
      throw N(i), new Error(i);
    }
    e.config.globalMessageInterceptor = null, I.info("%c unregister globalMessageInterceptor successfully!", "color: green; font-weight: bold");
  }
  function ce() {
    if (W)
      return e.config.globalMessageInterceptor;
    var n, i;
    return ((n = window[O]) === null || n === void 0 || (i = n.getGlobalMessageInterceptor) === null || i === void 0 ? void 0 : i.call(n)) || null;
  }
  function Ye(n) {
    var i = ce();
    if (i)
      try {
        var c = i(n);
        if (!c)
          return I.info("%cGlobal message interceptor returned false, skipping native postMessage for ".concat(n.functionName || n.apiName, "__").concat(n.jsCallId), "color: orange; font-weight: bold"), !1;
      } catch (l) {
        I.error("Error in globalMessageInterceptor callback", l);
      }
    return !0;
  }
  function Ln() {
    try {
      if (window[O] && !e.config.sharedBridge && !mn) {
        var n;
        if (!e.config.softRegisterBridge) {
          var i = "[@zoom/hybrid-jssdk] Failed to register the SDK object for ".concat(O, " because it already exists.");
          throw N(i, window.top !== window), new Error(i);
        }
        if (((n = window[O]) === null || n === void 0 ? void 0 : n.constructor) !== Object) {
          var c = "[@zoom/hybrid-jssdk] Failed to inject window.".concat(O, ". The window.").concat(O, " object should be a plain object.");
          throw N(c, window[O]), new Error(c);
        }
      }
      e.config.iframeSupport && (window.top === window ? w = An() : w = Hn());
      var l = {
        native2js: q,
        postJSMessage: k,
        postJsMessage: k,
        postMessage: Se,
        registerSubInstance: Re,
        unregisterSubInstance: Fe,
        isInstanceRegistered: Pe,
        registerGlobalMessageInterceptor: Ie,
        unregisterGlobalMessageInterceptor: Oe,
        getGlobalMessageInterceptor: ce,
        buildInfo: {
          buildTime: ke,
          version: ge
        }
      };
      if (W) {
        var f;
        I.info("%c start register master ".concat(O, "..."), "font-weight: bold", {
          sdkObject: window[O],
          sdkName: O,
          bridgeOptions: e
        }), e.config.softRegisterBridge || mn ? (window[O] || (window[O] = {
          native2js: q,
          registerSubInstance: Re,
          unregisterSubInstance: Fe,
          isInstanceRegistered: Pe,
          postJSMessage: k,
          postJsMessage: k,
          postMessage: Se,
          registerGlobalMessageInterceptor: Ie,
          unregisterGlobalMessageInterceptor: Oe,
          getGlobalMessageInterceptor: ce,
          buildInfo: {
            buildTime: ke,
            version: ge
          }
        }), pn(window[O], l), e.config.unifySDKMode ? e.config.isInterceptZoomSdkNative2js && qe() : (window.unifySdk = {
          native2js: q,
          registerSubInstance: Re,
          unregisterSubInstance: Fe,
          isInstanceRegistered: Pe,
          postJSMessage: k,
          postJsMessage: k,
          postMessage: Se,
          registerGlobalMessageInterceptor: Ie,
          unregisterGlobalMessageInterceptor: Oe,
          getGlobalMessageInterceptor: ce,
          buildInfo: {
            buildTime: ke,
            version: ge
          }
        }, pn(window.unifySdk, l))) : (Object.defineProperty(window, O, {
          value: l,
          writable: !1,
          enumerable: !1
        }), e.config.unifySDKMode ? e.config.isInterceptZoomSdkNative2js && qe() : Object.defineProperty(window, "unifySdk", {
          value: l,
          writable: !1,
          enumerable: !1
        })), $.isWebView2(window) && typeof ((f = window.chrome) === null || f === void 0 || (f = f.webview) === null || f === void 0 ? void 0 : f.addEventListener) == "function" && (y && window.chrome.webview.removeEventListener("message", y), window.chrome.webview.addEventListener("message", y = function(h) {
          h instanceof Event && h.data ? l.native2js(JSON.parse(JSON.stringify(h.data))) : l.native2js(h);
        })), I.info("%c register master ".concat(O, " successfully!"), "color: green; font-weight: bold", {
          sdkObject: window[O],
          unifySdkObject: window.unifySdk,
          sdkName: O,
          bridgeOptions: e
        }), _n();
      } else {
        var v;
        I.info("%c start register sub ".concat(O, " (").concat(B, ")..."), "font-weight: bold", {
          sdkObject: window[O],
          sdkName: O,
          bridgeOptions: e
        }), (v = window[O]) === null || v === void 0 || v.registerSubInstance({
          instanceId: B,
          onNativeResponse: q,
          isJsCallIdFromThisInstance: Dn,
          isThisInstanceRegisteredNotification: Kn
        });
      }
    } catch (S) {
      I.error("%c register ".concat(O, " failed!"), "color: red; font-weight: bold", {
        error: S,
        sdkObject: window[O],
        sdkName: O,
        bridgeOptions: e
      });
    }
  }
  function qe() {
    if (window.zoomSdk)
      if (Pr(window.zoomSdk, "native2js")) {
        var n = window.zoomSdk.native2js.bind(window.zoomSdk);
        window.zoomSdk.native2js = function(i) {
          var c = JSON.stringify(i);
          yn(n, JSON.parse(c)), yn(window.unifySdk.native2js, JSON.parse(c));
        }, I.info("%c intercepted zoomSdk.native2js successfully!", "color: green; font-weight: bold");
      } else
        I.warn("failed to intercept zoomSdk.native2js, window.zoomSdk.native2js is not writable.", window.zoomSdk);
    else
      I.warn("config isInterceptZoomSdkNative2js: true, but not found window.zoomSdk.native2js, zoomSdk is ", window.zoomSdk);
  }
  function q(n) {
    return Be.apply(this, arguments);
  }
  function Be() {
    return Be = H(/* @__PURE__ */ C().m(function n(i) {
      var c, l, f, v, S, h, m;
      return C().w(function(b) {
        for (; ; ) switch (b.p = b.n) {
          case 0:
            c = [].concat(br(D.map(function(L) {
              return L.handler;
            })), [Vn]), l = i, f = hn(c), b.p = 1, f.s();
          case 2:
            if ((v = f.n()).done) {
              b.n = 7;
              break;
            }
            if (S = v.value, l === void 0) {
              b.n = 6;
              break;
            }
            return b.p = 3, b.n = 4, S(l);
          case 4:
            l = b.v, b.n = 6;
            break;
          case 5:
            b.p = 5, h = b.v, console.error("Error in handler:", h);
          case 6:
            b.n = 2;
            break;
          case 7:
            b.n = 9;
            break;
          case 8:
            b.p = 8, m = b.v, f.e(m);
          case 9:
            return b.p = 9, f.f(), b.f(9);
          case 10:
            return b.a(2);
        }
      }, n, null, [[3, 5], [1, 8, 9, 10]]);
    })), Be.apply(this, arguments);
  }
  function zn(n) {
    var i = n.handler, c = n.priority, l = c === void 0 ? 0 : c, f = D.findIndex(function(v) {
      return v.priority < l;
    });
    f === -1 ? D.push({
      handler: i,
      priority: l
    }) : D.splice(f, 0, {
      handler: i,
      priority: l
    });
  }
  function _n() {
    k({
      functionName: "webview.ready",
      params: {},
      needResponse: !1
    }), !e.config.allowPendingNotification && window.__unfiySdk_pending_notification && _("[hybrid/bridge] not allow to check pending message, but __unfiySdk_pending_ has message in it."), e.config.isHookRequestBody && (window.zapp_local_load === "yes" ? tn() : _("Skip registerRequestBodyHook, window.zapp_local_load is undefined!"));
  }
  function Jn() {
    if (e.config.allowPendingNotification) {
      var n;
      (n = window.__unfiySdk_pending_notification) === null || n === void 0 || n.forEach(/* @__PURE__ */ function() {
        var i = H(/* @__PURE__ */ C().m(function c(l) {
          var f;
          return C().w(function(v) {
            for (; ; ) switch (v.p = v.n) {
              case 0:
                return v.p = 0, v.n = 1, q(l);
              case 1:
                v.n = 3;
                break;
              case 2:
                v.p = 2, f = v.v, _("[hybrid/bridge] handle __unfiySdk_pending_notification error", f, l);
              case 3:
                return v.a(2);
            }
          }, c, null, [[0, 2]]);
        }));
        return function(c) {
          return i.apply(this, arguments);
        };
      }()), delete window.__unfiySdk_pending_notification;
    } else
      _("[hybrid/bridge] skip checkPendingNotification, due to allowPendingNotification was false");
  }
  function An() {
    e.config.iframeAllowedOrigin.length || _("[hybrid] iframeSupport was true, but iframeAllowedOrigin is empty, please add origin in bridge config.");
    var n = e.config.iframeAllowedOrigin.map(gn), i = function(l) {
      var f = l.data, v = l.origin, S = vn(l.origin, n), h = e.config.iframeAllowNullOrigin && l.origin === "null";
      if ((S || h) && (f == null ? void 0 : f.identityKey) === e.config.iframeMessageIdentityKey) {
        var m = f.request, b = f.purpose, L = f.timeoutJsCallId, Q = f.raceId;
        if (b === "registerIframe")
          ir(l.source);
        else if (b === "unregisterIframe")
          ar(l.source);
        else if (b === "cleanTimeoutJsCall" && L)
          Un({
            jsCallId: L,
            raceId: Q
          });
        else {
          var ue = e.config.iframeOriginalValidator || function() {
            return !0;
          };
          ue(l) ? (m.needResponse && (m.iframeWindow = l.source), Se(m)) : I.warn("[hybrid] Received a message rejected by custom iframeOriginalValidator!", l);
        }
      } else (f == null ? void 0 : f.identityKey) === e.config.iframeMessageIdentityKey && I.warn("[hybrid] Received a invalid message or message sent from invalid origin ".concat(v), l);
    };
    return window.removeEventListener("message", i), window.addEventListener("message", i), {
      destroy: function() {
        window.removeEventListener("message", i), w = null;
      }
    };
  }
  function Hn() {
    if (!e.config.iframeAllowedOrigin.length)
      throw new Error("[@zoom/hybrid-jssdk] iframeSupport was true, but iframeAllowedOrigin is empty. Please add an origin to the bridge config’s iframeAllowedOrigin field, or disable iframe support.");
    var n = e.config.iframeAllowedOrigin.map(gn), i = /* @__PURE__ */ function() {
      var c = H(/* @__PURE__ */ C().m(function l(f) {
        var v, S, h, m, b;
        return C().w(function(L) {
          for (; ; ) switch (L.n) {
            case 0:
              if (v = f.data, S = f.origin, h = vn(f.origin, n), m = e.config.iframeAllowNullOrigin && f.origin === "null", !((h || m) && (v == null ? void 0 : v.identityKey) === e.config.iframeMessageIdentityKey)) {
                L.n = 2;
                break;
              }
              return b = v.response, L.n = 1, q(b);
            case 1:
              L.n = 3;
              break;
            case 2:
              (v == null ? void 0 : v.identityKey) === e.config.iframeMessageIdentityKey && I.warn("[hybrid] got a message from invalid origin ".concat(S), f);
            case 3:
              return L.a(2);
          }
        }, l);
      }));
      return function(f) {
        return c.apply(this, arguments);
      };
    }();
    return window.removeEventListener("message", i), window.addEventListener("message", i), window.top.postMessage({
      identityKey: e.config.iframeMessageIdentityKey,
      fromIframeURL: window.location.href,
      purpose: "registerIframe"
    }, "*"), {
      destroy: function() {
        window.removeEventListener("message", i), window.top.postMessage({
          identityKey: e.config.iframeMessageIdentityKey,
          fromIframeURL: window.location.href,
          purpose: "unregisterIframe"
        }, "*"), w = null;
      }
    };
  }
  function Pe(n) {
    if (!W) {
      var i = "[@zoom/hybrid-jssdk] can't call isInstanceRegistered on sub, current instanceId ".concat(n);
      throw N(i), new Error(i);
    }
    return j.some(function(c) {
      return c.instanceId === n;
    });
  }
  function Re(n) {
    var i;
    if (!W) {
      var c = "[@zoom/hybrid-jssdk] can’t registerSubInstance on sub, current instanceId ".concat(B);
      throw N(c), new Error(c);
    }
    (i = window[O]) !== null && i !== void 0 && i.isInstanceRegistered(n.instanceId) ? _("[Bridge::registerSubInstance] instance ".concat(n.instanceId, " already registered!")) : (j.push(n), G("%c register sub ".concat(O, " ").concat(n.instanceId, " successfully!"), "color: green; font-weight: bold", j));
  }
  function Fe(n) {
    var i;
    if (!W) {
      var c = "[@zoom/hybrid-jssdk] can’t unregisterSubInstance on sub. instanceId: ".concat(n);
      throw N(c), new Error(c);
    }
    if ((i = window[O]) !== null && i !== void 0 && i.isInstanceRegistered(n)) {
      var l = j.findIndex(function(f) {
        return f.instanceId === n;
      });
      j.splice(l, 1), G("%c unregister sub ".concat(O, " ").concat(n, " successfully!"), "font-weight: bold", j);
    } else
      _("[Bridge::unregisterSubInstance] instance ".concat(n, " not registered!"));
  }
  function Dn(n) {
    return !!o[n];
  }
  function Kn(n) {
    return !!u[n] || !!u[pe];
  }
  function Wn() {
    var n;
    (n = window[O]) === null || n === void 0 || n.unregisterSubInstance(B);
  }
  function Qe() {
    M = M.filter(function(n) {
      return !n.closed;
    }), Object.keys(P).forEach(function(n) {
      var i = P[n];
      i.closed && delete P[n];
    });
  }
  function Un(n) {
    if (window.top === window) {
      var i = n.jsCallId, c = n.raceId;
      P[i] && i && delete P[i], c && d.has(c) && (d.delete(c), p.delete(i)), Qe();
    }
  }
  function Vn(n) {
    if (Qe(), !n || He(n) !== "object") {
      I.warn("Native client send a invalid response to jsbridge, ignore it!", n);
      return;
    }
    var i = ae.find(function(S) {
      return S.matchResponse(n);
    }), c = i ? i.normalizeResponse(n) : Gn(n);
    if (c) {
      var l = c.jsCallId;
      if (l) {
        if (o[l]) {
          var f, v;
          (f = (v = o)[l]) === null || f === void 0 || f.call(v, c);
        } else P[l] ? (nr(P[l], c), delete P[l]) : rr(l, c);
        tr(l, c);
      } else
        $e(c), nn(c), rn(c);
      i != null && i.postProcessAsNotification(n) && ($e(c), nn(c), rn(c));
    }
  }
  function $e(n) {
    var i, c = n == null || (i = n.result) === null || i === void 0 ? void 0 : i.notification, l = n.type === "event" && !!n.name;
    if (l && !c && (c = n.name, n.result.notification = n.name), c) {
      I.info("%c".concat(l ? "Event" : "", " ").concat(c), "color: #0f00f0;font-weight:bold", n);
      var f = u[c], v = u[pe];
      f != null && f.length ? xe(f, n) : v != null && v.length || j.filter(function(S) {
        return S.isThisInstanceRegisteredNotification(c);
      }).length === 0 && I.info("%cReceived an unregistered notification: ".concat(c, ". Ignoring it."), "color:#909399;", n), v && xe(v, n);
    } else
      I.warn(`Failed to handle notification. The 'notification' field is missing in the response.
`, n);
  }
  function xe(n, i) {
    n.slice().forEach(function(c) {
      try {
        c(i);
      } catch (l) {
        N("invoke handler error", {
          e: l,
          handler: c,
          message: i
        });
      }
    });
  }
  function Gn(n) {
    if (Qn(n))
      return qn(n);
    var i = n;
    if ("jsCallId" in i)
      return i;
    if (Zn(i)) {
      var c = Xn(i);
      if (c.type === Dr) {
        var l, f;
        return T({
          jsCallId: (l = c.data.jsCallId) !== null && l !== void 0 ? l : "",
          returnCode: +((f = c.data.errorCode) !== null && f !== void 0 ? f : 0)
        }, c.data);
      } else if (c.type === Kr) {
        var v, S, h = c.data || {};
        return typeof h.eventData == "string" && (h.eventData = Br(h.eventData)), {
          jsCallId: "",
          returnCode: +((v = h.errorCode || ((S = h.eventData) === null || S === void 0 ? void 0 : S.returnCode)) !== null && v !== void 0 ? v : 0),
          result: T({
            notification: h.eventName || c.name
          }, h)
        };
      } else
        I.warn("Received an invalid appBridge response data structure, discarding it.", i);
    } else {
      if ("data" in i)
        return i.data;
      if (!i.jsCallId && "returnCode" in i && "result" in i && !("notification" in i))
        return i;
      var m = Yn(i);
      if (m)
        return m;
      I.warn("[hybrid] Received an invalid response data structure, discarding it.", i);
    }
  }
  function Zn(n) {
    if ("data" in n && "type" in n && (n.type === "event" && "name" in n || n.type === "apiResponse" && !("name" in n)))
      return !0;
    if ("data" in n && "data" in n.data && !("type" in n)) {
      var i = n.data;
      if (i.type === "event" && "name" in i || i.type === "apiResponse" && !("name" in i))
        return !0;
    }
    return !1;
  }
  function Xn(n) {
    if ("data" in n && "data" in n.data && !("type" in n))
      return n.data;
    if ("data" in n && "type" in n)
      return n;
  }
  function Yn(n) {
    return n.notification === "UnifyNotif_OnNetworkStateChanged" ? {
      jsCallId: "",
      returnCode: 0,
      result: T({}, n)
    } : !1;
  }
  function qn(n) {
    if (n.version === "v1.0") {
      if (n.type === "unifyNotification")
        return {
          jsCallId: "",
          returnCode: n.returnCode,
          errorMsg: n.errorMsg,
          result: {
            data: T({}, n.data),
            notification: n.notification
          }
        };
      if (n.type === "unifyResponse")
        return {
          jsCallId: n.jsCallId,
          returnCode: n.returnCode,
          errorMsg: n.errorMsg,
          result: T({}, n.data)
        };
    }
    throw new Error("[@zoom/hybrid-jssdk] new response message version is not supported. version: ".concat(n.version));
  }
  function Qn(n) {
    return "type" in n && "version" in n ? n.type === "unifyNotification" || n.type === "unifyResponse" : !1;
  }
  function je(n) {
    delete o[n];
  }
  function $n(n) {
    return o[n];
  }
  function xn(n) {
    var i = n.functionName || n.apiName;
    a[i] && delete a[i];
  }
  function er(n) {
    try {
      e.config.onMessageTimeout && e.config.onMessageTimeout(n);
    } catch (i) {
      N("invoke message timeout callback error", i);
    }
  }
  function en(n) {
    var i, c, l;
    return "F:".concat((i = n.functionName) !== null && i !== void 0 ? i : n.apiName, "_P:").concat(JSON.stringify((c = n.params) !== null && c !== void 0 ? c : {}), "_D:").concat(JSON.stringify((l = n.data) !== null && l !== void 0 ? l : {}));
  }
  function nr(n, i) {
    if (e.config.iframeSupport)
      try {
        I.info("%c forward response message to iframe!", "font-weight: bold", i), n.closed || n.postMessage({
          identityKey: e.config.iframeMessageIdentityKey,
          response: i
        }, "*");
      } catch (c) {
        N("[hybrid] forward response message to iframe error", c);
      }
  }
  function nn(n) {
    e.config.iframeSupport && M.length && (I.info("%c forward notification to iframe!", "font-weight: bold", n), M.filter(function(i) {
      return !i.closed;
    }).forEach(function(i) {
      i.postMessage({
        identityKey: e.config.iframeMessageIdentityKey,
        response: n
      }, "*");
    }));
  }
  function rr(n, i) {
    j.length && j.filter(function(c) {
      return c.isJsCallIdFromThisInstance(n);
    }).map(function(c) {
      c.onNativeResponse(i);
    });
  }
  function rn(n) {
    j.length && j.map(function(i) {
      i.onNativeResponse(n);
    });
  }
  function tr(n, i) {
    var c = p.get(n);
    if (c) {
      var l;
      (l = d.get(c)) === null || l === void 0 || l.forEach(/* @__PURE__ */ function() {
        var f = H(/* @__PURE__ */ C().m(function v(S) {
          var h;
          return C().w(function(m) {
            for (; ; ) switch (m.n) {
              case 0:
                if (S === n) {
                  m.n = 1;
                  break;
                }
                return h = JSON.parse(JSON.stringify(i)), h.jsCallId = S, m.n = 1, q(h);
              case 1:
                return m.a(2);
            }
          }, v);
        }));
        return function(v) {
          return f.apply(this, arguments);
        };
      }()), p.delete(n), d.delete(c);
    }
  }
  function or(n) {
    var i = n.reject, c = n.errorMessage, l = n.jsCallId, f = p.get(l), v = new Error(c);
    if (f) {
      var S = d.get(f) || [];
      S.forEach(function(h) {
        var m;
        delete s[h], je(h), (m = g.get(h)) === null || m === void 0 || m(v), g.delete(h);
      }), p.delete(l), d.delete(f), g.delete(l);
    } else
      delete s[l], g.delete(l), je(l), i(v);
  }
  function ir(n) {
    M.includes(n) || M.push(n);
  }
  function ar(n) {
    var i = M.indexOf(n);
    i > -1 && M.splice(i, 1);
  }
  function tn() {
    $.isMacOSWebkit(window) && Je(E, "6.3.0") >= 0 || $.isIOS(window) && Je(E, "6.6.0") >= 0 ? (zr(), G("%c hooked fetch/XMLHTTPRequest successfully!", "color: green; font-weight: bold")) : _("Skip registerRequestBodyHook, the iOS client version must be 6.6.0 or higher/ The Mac Zoom Client version must be 6.3.0 or higher. current client version(".concat(E, ")!"));
  }
  function sr() {
    $.isMacOS(window) && Je(E, "6.3.0") >= 0 ? (_r(), G("%c remove fetch/XMLHTTPRequest Hook successfully!", "color: brown; font-weight: bold")) : _("Skip unregisterRequestBodyHook, the iOS client version must be 6.6.0 or higher/ The Mac Zoom Client version must be 6.3.0 or higher. current client version(".concat(E, ")!"));
  }
  function cr() {
    return JSON.parse(JSON.stringify(e));
  }
  function ur() {
    return I;
  }
  return {
    config: he,
    getInstance: he,
    sendResponse: q,
    addNativeResponseHandler: zn,
    registerNotificationHandler: Y,
    checkPendingNotification: Jn,
    registerSpecificNotificationHandler: J,
    unregisterNotificationHandler: ne,
    unregisterSpecificNotificationHandler: R,
    unregisterInstance: Wn,
    postJsMessage: k,
    postJSMessage: k,
    clearTimeHandler: re,
    clearAPICallback: En,
    clearNotificationHandler: Bn,
    registerRequestBodyHook: tn,
    unregisterRequestBodyHook: sr,
    getNativeApiCallback: $n,
    interceptors: V,
    getBridgeOptions: cr,
    getLogger: ur,
    registerGlobalMessageInterceptor: Ie,
    unregisterGlobalMessageInterceptor: Oe,
    getGlobalMessageInterceptor: ce
  };
}
function Ar() {
  var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  return kn({
    config: {
      messageTimeout: Nn,
      longRequestSeconds: kr,
      wildCardNotificationType: pe,
      softRegisterBridge: !1,
      unifySDKMode: !1,
      messageFormat: "string",
      iframeSupport: !1,
      iframeAllowNullOrigin: !1,
      iframeAllowedOrigin: ["*"],
      iframeMessageIdentityKey: "ZM_UNIFY_HYBRID_MSG",
      sharedBridge: !0,
      allowPendingNotification: !0,
      disabledAdapters: [],
      isHookRequestBody: !1,
      iframeOriginalValidator: null,
      serviceHubSkipAddEventListener: !1,
      isInterceptZoomSdkNative2js: !1,
      checkReturnCode: !1,
      legacyPlatformDetection: !1,
      strictMode: !1,
      globalMessageInterceptor: null
    },
    debug: {
      enable: !0,
      output: {
        info: G,
        warn: _,
        error: N
      }
    }
  }, r);
}
function Hr() {
  var r;
  return function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return r ? (e && JSON.stringify(e) !== "{}" && _("Hybrid/bridge is already configured. The current options in getInstance will be ignored. You can call hybrid.config first to bypass this warning.", e), r) : r = me(e);
  };
}
var he = Hr();
me.getInstance = he;
me.config = he;
var Vr = he, Dr = "apiResponse", Kr = "event", Wr = /* @__PURE__ */ function(r) {
  function e(t, o, a, s) {
    var u;
    return x(this, e), u = gr(this, e, [t]), Z(u, "code", void 0), Z(u, "requestId", void 0), Z(u, "response", void 0), u.code = o, u.requestId = a, u.response = s, Object.setPrototypeOf(u, e.prototype), u;
  }
  return pr(e, r), ee(e);
}(/* @__PURE__ */ De(Error));
export {
  me as Bridge,
  Wr as ZoomApiResponseError,
  Je as compareVersions,
  Vr as config,
  Er as getJsCallId,
  Ur as isInWebview,
  $ as platformBridgeChecker
};
//# sourceMappingURL=hybrid-jsbridge.es.js.map
